"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var SINGLE_QUOTE = /'/g;
var DIACRITICAL_MARKS = /[\u0300-\u036f]/g;
var INCHES = /([0-9]+)["”]/g;
var NON_ALPHA_NUMERIC = /[^A-Za-z0-9]/g;
var CONTIGUOUS_WHITESPACE = /\s+/g;
var sanitiseString = function sanitiseString(string) {
  return string.normalize('NFD').replace(SINGLE_QUOTE, '').replace(DIACRITICAL_MARKS, '').replace(INCHES, '$1 inch').replace(NON_ALPHA_NUMERIC, ' ').trim().replace(CONTIGUOUS_WHITESPACE, '-').toLowerCase();
};
var getProductUrl = function getProductUrl(title, id, selectedSwatch, adId) {
  var fragmentId = adId ? "#citrusAdId=".concat(adId) : '';
  if (selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.canonicalURL || selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.url) {
    var url = (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.canonicalURL) || (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.url);
    return "".concat(url).concat(fragmentId);
  }
  var encodedTitle = sanitiseString(title);
  if (selectedSwatch && Object.keys(selectedSwatch).length) {
    var color = selectedSwatch.color;
    return "/".concat(encodedTitle).concat(color ? "/".concat(sanitiseString(color)) : '', "/p").concat(id).concat(fragmentId);
  }
  return "/".concat(encodedTitle, "/p").concat(id).concat(fragmentId);
};
var _default = exports["default"] = getProductUrl;